const UNITS = ['B', 'KB', 'MB', 'GB']

// A size in bytes, 1024-based with one decimal above a byte ("300.0 MB",
// "512 B"). Not table-columns' formatSize, which divides values under 1024
// by 8.
export const formatBytes = n => {
  const bytes = Number(n)
  if (n === null || n === undefined || n === '' || !Number.isFinite(bytes)) return '—'
  if (bytes < 1024) return `${Math.round(bytes)} B`
  let value = bytes
  let unit = 0
  while (value >= 1024 && unit < UNITS.length - 1) { value /= 1024; unit++ }
  return `${value.toFixed(1)} ${UNITS[unit]}`
}

// The GitHub page of a commit, or null unless both are known.
export const commitURL = (repo, commit) => (repo && commit ? `https://github.com/${repo}/commit/${commit}` : null)
